import { render, staticRenderFns } from "./VideoAdmin.vue?vue&type=template&id=0252d7d2&scoped=true&"
import script from "./VideoAdmin.vue?vue&type=script&lang=js&"
export * from "./VideoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0252d7d2",
  null
  
)

export default component.exports